<template>
  <header class="mainHeader" style="-webkit-text-size-adjust: none;">
    <div class="flex items-center justify-between px-2 header-nav w1200">

      <div class="clearfix searchNav">
        <a class="fl headLogo" href="/" style="position:absolute; top: 16px; left: -150px;">
           <span class="nowShow blueBg borderRadius ml20 mr10 nowStuSection"></span>
           <!-- <span class="font-bold">首页</span>   -->
          <img src="../../assets/images/common/logoOuter.png" /> 
        </a>
        <!-- <span>首页</span> -->
        <!-- <span class="nowShow blueBg borderRadius ml20 mr10 nowStuSection"></span>
        <div class="searchBox" v-if="false">
          <input placeholder="请输入关键字" />
          <button class="noBorderBtn"></button>
        </div> -->
      </div>
      <!-- v-if="!$route.fullPath" -->
      <div class="w-[900px]"  v-if="$route.fullPath">
        <el-menu
          :default-active="activeIndex"
          class="el-menu-demo"
          mode="horizontal" style="font-size: 20px;">
          <el-menu-item index="1" @click="scrollToSection('section0')">首页</el-menu-item>
          <el-menu-item index="2" @click="scrollToSection('section1')" >学科资源</el-menu-item>
          <el-menu-item index="3" @click="scrollToSection('section2')" >科技教育</el-menu-item>
          
          <el-menu-item index="4" @click="scrollToSection('section3')" >劳动素养</el-menu-item>
          <!-- <el-menu-item index="6" @click="jumpOutStem" >STEM教育</el-menu-item> -->
          <el-menu-item index="5" @click="scrollToSection('section4')" >教师培训</el-menu-item>
          <el-sub-menu index="8">
            <template #title>更多资源</template>
            <el-menu-item index="8-1" @click="jumpOutSite('1')">云教材</el-menu-item>
            <el-menu-item index="8-2" @click="jumpOutSite('2')">数学教学资源平台</el-menu-item>
          
          </el-sub-menu>
        </el-menu>
      </div>
     <div class="flex justify-center items-center" style="-webkit-text-size-adjust: none;">
        <!-- <router-link to="/download" class="mr-4 font-bold flex justify-center items-center">
          <el-link type="primary" class="font-bold text-base">资源下载</el-link>
        </router-link> -->
        <!-- <router-link to="/ucenter/index" v-if="isLogin">
            <span class="inline-block px-4 py-1 my-5 text-white bg-[#fb8056] bg-linear rounded-lg ml-4">个人中心</span>
          </router-link>
        <div v-if="isLogin">
          <span @click="doLogout" class="inline-block px-4 py-1 my-5 text-white bg-gray-400  rounded-lg ml-4">退出登录</span>
        </div> -->

        <div v-if="isLogin">
            <div class="inline-block px-4 py-1 my-5 text-white bg-[#fb8056] bg-linear rounded-lg ml-4">
              <router-link to="/ucenter/index" v-if="isLogin" class="text-white">
                个人中心
              </router-link>
              <span style="margin: 0 10px;">|</span>
               <span @click="doLogout" class="inline-block text-white cursor-pointer">退出登录</span>
            </div>
        </div>

        <div v-if="!isLogin" class="flex">
          <button class="mx-2 noBorderBtn loginIn font-bold" @click="showLoginModal=true">登录</button>
          |
          <button class="mx-2 noBorderBtn register font-bold" @click="showRegisterModal=true">免费注册</button>
        </div>
     </div>
     <LoginModal :show="showLoginModal" @update:show="val => showLoginModal = val" @login:success="loginSuccessHandle" />
     <RegisterModal :show="showRegisterModal" @update:show="val => showRegisterModal = val" @register:success="registerSuccessHandle" />
    </div>
  </header>
</template>
<script lang="ts" setup>
import useJump from "../../hooks/useJump";
import CommonUtils from "../../utils/CommonUtils";
import UserService from "../../apis/UserService";
import MittUtil from "../../utils/MittUtil";


const jumpOutStem = () => {
  // alert(1)
  window.open("https://kxsy.ooowin.com/oldstem/dist/index_courses.html", "_blank");
};
const showLoginModal = ref(false);
const showRegisterModal = ref(false);
const isLogin = ref(false);
const activeIndex = ref("1");
//@ts-ignore
MittUtil.on("isLogin", (e:boolean) => {
  console.log("MittUtil", e);
  isLogin.value = e;
});
const jump = useJump();

onMounted(() => {
  if (CommonUtils.isLogin()) {
    isLogin.value = true;
  } else {
    isLogin.value = false;
  }
});
const doLogout = () => {
  UserService.logout();
  setTimeout(()=>{
    CommonUtils.clearLocalStore();
    jump("/");
    MittUtil.emit("isLogin", false);
  },60)
};

const loginSuccessHandle = ()=>{
  MittUtil.emit("isLogin", true);
}
const registerSuccessHandle = ()=>{
  //TODO 注册成功
  showRegisterModal.value = false;
}

// 定义一个函数 scrollToSection，用于将页面滚动到指定的区域
// sectionId 参数为目标区域的 id
const scrollToSection = (sectionId:string) => {
  if(sectionId === "section0") {
    jump("/");
    return;
  }
  // 通过 document.getElementById 方法获取具有指定 id 的元素
  const element = document.getElementById(sectionId);
  // 获取当前 path  
  const currentPath = window.location.pathname;
  console.log("currentPath", currentPath);
  if (currentPath !== "/") {
    jump("/");
    return;
  }
  // 检查元素是否存在
  if (element) {
    // 若元素存在，调用 scrollIntoView 方法将元素滚动到可见区域
    element.scrollIntoView({
      behavior: 'smooth', // 设置滚动行为为平滑滚动，使页面滚动时具有动画效果
      block: 'start', // 设置滚动的对齐方式为元素顶部与窗口顶部对齐
      inline:'nearest' // 设置滚动的对齐方式为元素最接近的边缘与窗口最接近的边缘对齐
      
    });
  }else {
    console.log("元素不存在");
  }
};
const jumpOutSite = (type:string) => {
  if(type === "1") {
    window.open("http://yjc.zjeph.com/", "_blank");
  }else if(type === "2") {
    window.open("http://yjc.zjeph.com:8081/#/user/login", "_blank");
  }
};
</script>
<style lang="scss">
.header-nav {
  position: relative;
  left: -60px;
  .el-menu-item {
   font-size: 20px; 
   font-weight: 500;
  }
  .el-sub-menu__title { 
    font-size: 20px; 
    font-weight: 500;
  } 
  .el-menu-item.is-active {
   color: #000202!important;
   border-bottom: 2px solid #950000!important;
   font-weight: 600;
  } 

  .el-menu-item.is-active {
   color: #000202!important;
   border-bottom: 2px solid #950000!important;
   font-weight: 600;
  }
}
</style>
